import Loans from "@Images/Loans-Image.webp";
import LoanNotActive from "@Images/LoansNotActive.webp";
import Payme from "@Images/mmblogo.webp";
import PaymeNotActive from "@Images/PaymeNotActive.webp";
import "@Styles/mandate.css";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

function ToggleBar(props) {
  const [activeState, setActiveState] = useState(props.activeState || false);
  const [cibilCheck, setCibilCheck] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (props.documentStatus) {
      setCibilCheck(props.documentStatus?.cibil_form);
    }
    if (location.pathname === "/dashboard_s") {
      setActiveState("A");
    } else if (location.pathname === "/super-loan-dashboard") {
      setActiveState("B");
    }
  }, [props.documentStatus, location.pathname]);

  return (
    <div className="downwardFlexContainer">
      <div className="toolbarRespo">
        <div className="downwardFlex downwardFlexWrapper">
          <div
            onClick={() => navigate("/dashboard_s")}
            className={`downwardBox ${activeState === "A" ? "imageBorderBox" : ""}`}
          >
            <img
              alt="payme image"
              className="downwardImageDashboard"
              src={activeState === "A" ? Payme : PaymeNotActive}
            />
          </div>
          <div
            onClick={() => {
              cibilCheck
                ? (window.location.href = "/creditlimit")
                : navigate("/super-loan-dashboard");
            }}
            className={`downwardBox ${activeState === "B" ? "imageBorderBox" : ""}`}
          >
            <img
              className="downwardImageDashboard"
              src={activeState === "B" ? Loans : LoanNotActive}
              alt="loans image"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
  userDetail: state.userDetail,
});

export default connect(mapStateToProps)(ToggleBar);
